module.exports = __webpack_public_path__ + "img/Icon-Search.7e20ba46.svg";